module.exports = __webpack_public_path__ + "static/img/c_crm53.8cd22ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/c_crm53.jpg
// module id = +upJ
// module chunks = 73